<template>
  <div class="live-match-info-wrap">
    <div class="live-match-info">
      <div class="team home-team">
        {{ event.homeTeam }}
      </div>
      <div class="devider">
        vs
      </div>
      <div class="team away-team">
        {{ event.awayTeam }}
      </div>
    </div>

    <div class="switch-tip">
      If the live stream doesn't fit to this match, please switch here -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'MatchInfo',
  props: {
    event: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="less" scoped>
@import url("~wap/common/style/variable.less");
@import url("~wap/common/style/mixin.less");

.live-match-info-wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 44/@rem;
  background: rgba(0, 0, 0, 70%);

  .switch-tip {
    margin-top: 3/@rem;
    color: #ccc;
    font-size: 10/@rem;
    line-height: 1;
    text-align: center;
  }
}

.live-match-info {
  display: flex;
  justify-content: center;
  background: rgba(0, 0, 0, 70%);
  color: #fff;

  .team {
    width: (110/360) *100%;
    flex: none;
    font-size: 12/@rem;
    line-height: 22/@rem;
    .ellipsis();
  }

  .home-team {
    text-align: right;
  }

  .away-team {
    text-align: left;
  }

  .devider {
    flex: none;
    margin: 0 10/@rem;
    font-size: 18/@rem;
    line-height: 1;
  }
}

</style>
